import React from 'react';
import styles from '../../styles/PortalEstudiantesStyles/PortalEstudiantes.module.css';

function PagoErrorModal({ onClose }) {
  const codigoError = 'ERR-402';

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={`${styles.modalHeader} ${styles.errorHeader}`}>
          <div className={styles.errorIcon}>!</div>
          <h3 className={styles.modalTitle}>No se pudo procesar el pago</h3>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.errorMessage}>
            Ocurrió un error al intentar realizar el pago.
          </p>
          
          <div className={styles.errorDetalles}>
            <div className={styles.detalleRow}>
              <span className={styles.detalleLabel}>Código de error:</span>
              <span className={styles.detalleValue}>{codigoError}</span>
            </div>
          </div>

          <p className={styles.errorInfo}>
            Por favor, intenta nuevamente o comunícate con soporte proporcionando este código
          </p>
        </div>

        <div className={styles.modalFooter}>
          <button 
            className={styles.closeButton}
            onClick={onClose}
          >
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default PagoErrorModal;
